import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { css } from '@emotion/react';
import { visuallyHidden } from '../../../foundations/accessibility/visually-hidden.js';
import { iconSize } from '../../../foundations/__generated__/size.js';
const Svg = ({ size, theme }) => /* @__PURE__ */ jsx("svg", {
    width: size ? iconSize[size] : void 0,
    height: void 0,
    viewBox: "-3 -3 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false,
    "aria-hidden": true,
    children: /* @__PURE__ */ jsx("path", {
        d: "M12 2C6.467 2 2 6.467 2 12s4.467 10 10 10 10-4.467 10-10S17.533 2 12 2m1.133 13.933v.49c-.11.088-.266.155-.422.244a13 13 0 0 1-.511.2 2.4 2.4 0 0 1-.533.133 4 4 0 0 1-.511.044c-.356 0-.578-.066-.712-.2a.58.58 0 0 1-.222-.444c0-.178.022-.356.045-.533.022-.178.066-.356.11-.578l.934-4.245-.867-.2v-.466c.134-.045.312-.111.556-.178.222-.067.467-.111.733-.156.267-.044.511-.088.756-.11.244-.023.467-.045.667-.045l.244.155-1.244 5.89zm.423-7.466c-.2.177-.49.266-.823.266q-.465 0-.8-.266a.88.88 0 0 1-.31-.69c0-.31.11-.555.31-.733q.3-.266.8-.266c.356 0 .623.089.823.266s.31.423.31.734c-.022.289-.11.51-.31.689",
        fill: theme?.fill
    })
});
const SvgInfoRound = ({ size, theme, isAnnouncedByScreenReader = false }) => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Svg, { size, theme }),
        isAnnouncedByScreenReader ? /* @__PURE__ */ jsx("span", {
            css: css `
					${visuallyHidden}
				`,
            children: "Information"
        }) : ""
    ] });
export { SvgInfoRound };
